import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
//import Title from './Title';
import {Theme} from './Theme';

interface Props {
    isOpen:boolean,
}

const SuspendedSuccess:React.FC<Props> = (props)=> {
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
    if( !props.isOpen ){
        return (null);
    }

	const close = ()=>{

    }

	const reload = ()=>{
		window.location.reload();
	}

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={close}
			fullScreen={fullScreen}			
		>
			<DialogTitle color='primary'>一時停止を解除しました</DialogTitle>
			<DialogContent>
				作品や作家プロフィールページが公開されました<br/>
				SideBは画面をリロードすると再開されます<br/>
				<br/>
				<br/>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" color="primary" onClick={reload}>リロードする</Button>
			</DialogActions>
        </Dialog>

    );
}

export default SuspendedSuccess;
